import axios from "axios";

const fetchCompanies = (config) => {
  return axios.get("/api/v1/machine_learning", {
    ...config,
  });
};

const startLearning = (company_id) => {
  return axios.post(`/api/v1/machine_learning/${company_id}/learn`);
};

const ApiMachineLearning = {
  fetchCompanies,
  startLearning,
};

export default ApiMachineLearning;
